/* Corazon cart drawer: the theme's own slide-out cart (replaces the Upcart app). Loaded `defer` from
   snippets/cgc-cart-assets.liquid, before theme.js. Markup: sections/cgc-cart-drawer.liquid (rendered in every page,
   hidden until opened; re-rendered through the Section Rendering API after each cart change).

   Two modes, decided once when this file runs:
     - native (Upcart's app embed is off, so window.upcartSettings is absent): this drawer is the cart.
     - upcart (the embed is still on): this file stays out of the way and window.CGCCart forwards to Upcart, so the
       same theme code works before and after the embed is switched off (and again if it is switched back on).

   Public API (builders call it after their own /cart/add.js):
     CGCCart.open()     opens the drawer (re-rendered first when the cart changed); returns false if it can't
     CGCCart.close()
     CGCCart.refresh()  re-renders from the server; returns a Promise
     CGCCart.cart       { item_count, real_count, total_price, items: [{ key, variant_id, product_id, quantity }] }
   Opens by itself after any successful /cart/add(.js) request on the page (fetch or XHR, any script or app), after a
   product <form action="/cart/add"> submit that no other script took over (posted as FormData to /cart/add.js, so
   file uploads and line properties survive), on the header cart icon, and on the 'cart:open' / 'ajaxProduct:added'
   events. Other /cart/change|update|clear requests re-render it. All cart writes use the standard /cart/*.js
   endpoints through window.fetch, so Shopify's own cart events still fire. Nothing runs until a cart change or the
   first open, apart from reading the cart summary the page already printed. */
(function () {
  'use strict';
  if (window.CGCCart && window.CGCCart.__v) return;
  var API = window.CGCCart = { __v: 1 };

  /* ---------- upcart mode: forward to the app, exactly as the builders did before ---------- */
  if (window.upcartSettings) {
    API.mode = 'upcart';
    /* UploadKit: don't add while one of its upload fields is invalid (was inline in layout/theme.liquid) */
    window.upcartShouldAddToCartContinue = function (evt) {
      if (evt.target && evt.target.parents('.uploadkit-invalid').length) {
        return false;
      }
      return true;
    };
    API.open = function () {
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; } } catch (e) {}
      return false;
    };
    API.refresh = function () { try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {} return Promise.resolve(); };
    API.close = function () {
      var r = document.getElementById('upCart'), s = r && (r.shadowRoot || r);
      var x = s && s.querySelector('[aria-label*="lose" i], button[class*="close" i]');
      if (x) x.click();
    };
    return;
  }

  /* ---------- native mode ---------- */
  API.mode = 'native';
  var SECTION = 'cgc-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADD = /\/cart\/add(\.js)?(\?|#|$)/;
  var MUTATE = /\/cart\/(change|update|clear)(\.js)?(\?|#|$)/;
  var HTML = document.documentElement;
  /* Impulse's own drawer and AJAX product forms would open a second cart: switch them off (theme.js runs after us) */
  if (window.theme && theme.settings && theme.settings.cartType === 'drawer') theme.settings.cartType = 'cgc-drawer';

  var FOLDS = {};
  try { FOLDS = JSON.parse(sessionStorage.getItem('cgcd_folds') || '{}') || {}; } catch (e) {}
  var D = null, isOpen = false, lastFocus = null, closeT = null, dirty = false, inflight = null, again = false, busyN = 0;
  function drawer() { if (!D || !D.isConnected) D = document.getElementById('CgcCartDrawer'); return D; }
  function content() { var d = drawer(); return d && d.querySelector('[data-cgcd-content]'); }

  /* ---------- requests (always through the current window.fetch: Shopify's pixels and the count watcher see them) ---------- */
  function own(init) { init = init || {}; init.__cgcd = true; init.credentials = 'same-origin'; return init; }
  function sectionsHTML(j) { return j && j.sections && j.sections[SECTION]; }
  function postJSON(path, body) {
    body.sections = SECTION; body.sections_url = ROOT;
    return window.fetch(ROOT + path, own({ method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) }))
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || ('Cart error ' + r.status)); e.status = r.status; throw e; } return j; }); });
  }
  function fetchSection() {
    return window.fetch(ROOT + '?sections=' + SECTION, own({ headers: { Accept: 'application/json' } }))
      .then(function (r) { if (!r.ok) throw new Error('drawer ' + r.status); return r.json(); })
      .then(function (j) { return j && j[SECTION]; });
  }

  /* ---------- render ---------- */
  function readCart(scope) {
    var s = scope && scope.querySelector('script[data-cgcd-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function apply(html) {
    var cur = content();
    if (!html || !cur) return false;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var next = tmp.querySelector('[data-cgcd-content]');
    if (!next) return false;
    /* keep the scroll position and the focused control across the swap */
    var sc = cur.querySelector('[data-cgcd-scroll]'), top = sc ? sc.scrollTop : 0;
    var a = document.activeElement, fk = a && cur.contains(a) ? a.getAttribute('data-fk') : null;
    /* folded rows (cart test 10-19: "+ 3 extras", "Add a finishing touch") stay open across the swap */
    [].forEach.call(next.querySelectorAll('details[data-cgcd-fold]'), function (el) { if (FOLDS[el.getAttribute('data-cgcd-fold')]) el.open = true; });
    cur.parentNode.replaceChild(next, cur);
    var sc2 = next.querySelector('[data-cgcd-scroll]'); if (sc2) sc2.scrollTop = top;
    if (isOpen && a && cur.contains(a)) {
      var f = (fk && next.querySelector('[data-fk="' + (window.CSS && CSS.escape ? CSS.escape(fk) : fk) + '"]')) || drawer().querySelector('.cgcd__panel');
      if (f) try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }
    dirty = false;
    after(next, true);
    return true;
  }
  /* everything that follows a render: count, protection, design thumbnails, Afterpay, the Transcy price on the row */
  function after(scope, announce) {
    var c = readCart(scope);
    if (c) {
      var was = API.cart; API.cart = c;
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c, source: 'cgc-drawer' } })); } catch (e) {}
      var cc = window.__cgcCart;
      if (cc && cc.remember) cc.remember(c);
      if (announce && was && was.real_count !== c.real_count) say((c.real_count === 1 ? '1 item' : c.real_count + ' items') + ' in your cart');
    }
    if (window.__cgcCart && window.__cgcCart.refresh) window.__cgcCart.refresh();   /* protection price in the shown currency */
    localThumbs(scope); fillAp(scope);
  }
  function say(t) { var l = drawer() && drawer().querySelector('[data-cgcd-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = t; }, 60); } }

  /* the customer's own design, kept in this browser until the upload backend sets `_preview` (same as /cart) */
  function localThumbs(scope) {
    [].forEach.call(scope.querySelectorAll('[data-design-id]:not(.cgc-cl--child),[data-render-id]:not(.cgc-cl--child)'), function (line) {   /* add-ons (the plaque's stand) keep their own photo */
      var img = line.querySelector('.cgc-cl__img');
      if (!img || img.classList.contains('is-custom')) return;
      var id = line.getAttribute('data-design-id'), rid = line.getAttribute('data-render-id'), src = null;
      try {
        if (id) src = window.CGCPreviewStore ? CGCPreviewStore.getLocalPreview(id) : localStorage.getItem('cgc_preview:' + id);
        if (!src && rid) src = localStorage.getItem('mpb_render_' + rid);
      } catch (e) {}
      if (!src || src.indexOf('data:image/') !== 0) return;
      img.innerHTML = '<img src="' + src + '" alt="" width="160" height="160">';
      img.classList.add('is-custom');
    });
  }
  /* Afterpay: split the subtotal as shown (Transcy converts it after insertion), so 4 x amount = the shown subtotal */
  var apMO = null;
  function fillAp(scope) {
    var ap = scope.querySelector('[data-cgc-ap]'), sub = scope.querySelector('[data-cgc-subtotal]');
    if (!ap || !sub) return;
    var run = function () {
      var api = window.__cgcCart, cents = +ap.getAttribute('data-cents'), n = +ap.getAttribute('data-n') || 4;
      if (!(cents >= 100 && cents <= 200000) || !api || !api.installment) { ap.hidden = true; return; }
      var html = api.installment(sub.textContent.replace(/\s+/g, ' ').trim(), cents, n);
      var out = ap.querySelector('[data-cgc-ap-amount]');
      if (html && out.__h !== html) { out.innerHTML = html; out.__h = html; }
      ap.hidden = !html;
    };
    run();
    if (apMO) apMO.disconnect();
    if (window.MutationObserver) { apMO = new MutationObserver(run); apMO.observe(sub, { childList: true, subtree: true, characterData: true }); }
  }

  function refresh() {
    if (inflight) { again = true; return inflight; }
    busy(true);
    inflight = fetchSection().then(apply).catch(function (e) { console.warn('[cgc-drawer] refresh', e); })
      .then(function () { busy(false); inflight = null; if (again) { again = false; return refresh(); } });
    return inflight;
  }
  function busy(on) {
    busyN = Math.max(0, busyN + (on ? 1 : -1));
    var d = drawer(); if (d) d.classList.toggle('is-busy', busyN > 0);
  }
  function showErr(msg) {
    var e = content() && content().querySelector('[data-cgcd-err]');
    if (!e) return;
    e.textContent = msg; e.hidden = !msg;
  }
  /* a cart write from inside the drawer: one request that also returns the re-rendered drawer */
  function write(path, body) {
    busy(true); showErr('');
    return postJSON(path, body).then(function (j) {
      if (!apply(sectionsHTML(j))) return refresh();
    }).catch(function (e) {
      console.warn('[cgc-drawer]', path, e);
      return refresh().then(function () { showErr(e.status === 422 && e.message ? e.message : 'Something went wrong. Please try again.'); });
    }).then(function () { busy(false); });
  }

  /* ---------- open / close ---------- */
  var sbw = 0;
  function lock() {
    sbw = window.innerWidth - HTML.clientWidth;
    HTML.classList.add('cgcd-lock');
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }
  function unlock() { HTML.classList.remove('cgcd-lock'); document.body.style.paddingRight = ''; }
  function open() {
    var d = drawer();
    if (!d) { return false; }
    if (dirty && !inflight) refresh();
    if (isOpen) return true;
    clearTimeout(closeT);
    if (!lastFocus && !d.contains(document.activeElement)) lastFocus = document.activeElement;
    d.hidden = false;
    void d.offsetWidth;   /* start the slide from the closed position */
    d.classList.add('is-open'); isOpen = true;
    lock(); setExpanded(true);
    /* focus the dialog itself (announced by its title; no focus ring on a tap); Tab then reaches the close button */
    var x = d.querySelector('.cgcd__panel');
    setTimeout(function () { if (isOpen && x) try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }, 30);
    var c = content(); if (c) { localThumbs(c); fillAp(c); }
    try { document.dispatchEvent(new CustomEvent('cgc:cart-drawer', { detail: { open: true } })); } catch (e) {}
    return true;
  }
  function close() {
    var d = drawer();
    if (!d || !isOpen) return;
    var osh = d.querySelector('[data-cgcd-sheet]:not([hidden])'); if (osh) osh.hidden = true;
    d.classList.remove('is-open'); isOpen = false;
    setExpanded(false);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeT = setTimeout(function () { if (!isOpen) { d.hidden = true; unlock(); } }, reduce ? 0 : 320);
    if (reduce) { d.hidden = true; unlock(); }
    var back = lastFocus; lastFocus = null;
    var refocus = function () { if (back && back.focus && document.contains(back) && !isOpen) try { back.focus({ preventScroll: true }); } catch (e) {} };
    refocus();
    /* the theme's own Escape handling can blur right after us: put focus back once it is done */
    setTimeout(function () { var a = document.activeElement; if (!a || a === document.body) refocus(); }, 80);
    try { document.dispatchEvent(new CustomEvent('cgc:cart-drawer', { detail: { open: false } })); } catch (e) {}
  }
  function setExpanded(on) {
    [].forEach.call(document.querySelectorAll('.js-drawer-open-cart'), function (a) { a.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  API.open = open; API.close = close; API.refresh = refresh;
  API.isOpen = function () { return isOpen; };

  /* after an add made elsewhere: re-render, open as soon as the new cart is in (or after 350 ms, busy until then) */
  function added() {
    dirty = true;
    var p = refresh(), shown = false;
    var go = function () { if (!shown) { shown = true; open(); } };
    p.then(go); setTimeout(go, 350);
  }

  /* ---------- watch every cart request on the page (fetch + XHR) ---------- */
  function urlOf(input) { try { return typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) { return ''; } }
  function onDone(url) { if (ADD.test(url)) added(); else if (MUTATE.test(url)) { dirty = true; refresh(); } }
  if (window.fetch) {
    var prevFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = prevFetch.apply(this, arguments);
      try {
        var url = urlOf(input);
        if (!(init && init.__cgcd) && (ADD.test(url) || MUTATE.test(url)) && !/[?&]sections=/.test(url)) {
          p.then(function (res) { if (res && res.ok) onDone(url); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__cgcdUrl = String(url || ''); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, url = x.__cgcdUrl || '';
    if (ADD.test(url) || MUTATE.test(url)) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) onDone(url); });
    return xSend.apply(this, arguments);
  };

  /* ---------- product forms: <form action="/cart/add"> that no other script took over ----------
     Listened for on window (after every document-level handler: Globo, UploadKit and the keepsake builder validate or
     post the form themselves and call preventDefault; those are left alone). */
  function formError(form, msg) {
    var old = form.querySelector('.errors.cgcd-form-err'); if (old) old.remove();
    var d = document.createElement('div'); d.className = 'errors text-center cgcd-form-err'; d.setAttribute('role', 'alert'); d.textContent = msg;
    form.appendChild(d);
  }
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || form.tagName !== 'FORM' || !drawer()) return;
    var action = form.getAttribute('action') || '';
    if (!ADD.test(action.split('?')[0]) || String(form.method).toLowerCase() !== 'post') return;
    e.preventDefault();
    if (form.querySelector('.uploadkit-invalid') || form.closest('.uploadkit-invalid')) return;   /* UploadKit shows its own message */
    if (form.__cgcdBusy) return;
    var fd;
    try { fd = e.submitter ? new FormData(form, e.submitter) : new FormData(form); } catch (er) { fd = new FormData(form); }
    var body = new FormData();
    fd.forEach(function (val, key) {
      if (typeof File !== 'undefined' && val instanceof File && (!/^properties\[/.test(key) || (!val.name && !val.size))) return;   /* only real uploads that are line properties */
      body.append(key, val);
    });
    body.append('sections', SECTION); body.append('sections_url', ROOT);
    var btn = e.submitter || form.querySelector('[type="submit"], [name="add"]');
    form.__cgcdBusy = true; if (btn) { btn.classList.add('btn--loading'); btn.setAttribute('aria-busy', 'true'); }
    var old = form.querySelector('.cgcd-form-err'); if (old) old.remove();
    var done = function () { form.__cgcdBusy = false; if (btn) { btn.classList.remove('btn--loading'); btn.removeAttribute('aria-busy'); } };
    window.fetch(ROOT + 'cart/add.js', own({ method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body }))
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          done();
          if (!r.ok) { formError(form, j.description || j.message || 'Could not add to cart'); return; }
          if (!apply(sectionsHTML(j))) dirty = true;
          open();
          try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: j, addToCartBtn: btn, source: 'cgc-drawer' } })); } catch (er) {}
        });
      })
      .catch(function () { done(); HTMLFormElement.prototype.submit.call(form); });   /* network trouble: the normal form post */
  });

  /* ---------- clicks ---------- */
  function line(el) { return el.closest('[data-key]'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* header cart icon (and anything marked data-cgcd-open) */
    var opener = t.closest('.js-drawer-open-cart, [data-cgcd-open]');
    if (!opener) {   /* any other "view cart" link to /cart (e.g. the plaque builder's) opens the drawer too, as Upcart did */
      var a = t.closest('a[href]');
      if (a && !a.closest('[data-cgcd]') && !a.target) {
        try { var u = new URL(a.href, location.href); if (u.origin === location.origin && u.pathname.replace(/\/$/, '') === ROOT + 'cart' && !u.hash) opener = a; } catch (er) {}
      }
    }
    if (opener && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) && drawer()) {
      e.preventDefault(); e.stopPropagation();
      lastFocus = opener; open(); return;
    }
    var d = drawer();
    if (!d || !d.contains(t)) return;
    if (t.closest('[data-cgcd-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-qty]');
    if (q) {
      var ln = line(q); if (!ln) return;
      e.preventDefault();
      if (d.classList.contains('is-busy')) return;
      var grp = ln.classList.contains('cgc-cl--parent') && q.hasAttribute('data-remove') && ln.closest('.cgc-cl-group');
      if (grp) {
        /* add-ons grouped only by product rule (no bundle key) were added on their own: they stay */
        var keep = ',' + (grp.getAttribute('data-rule-kids') || '');
        var u = {}; [].forEach.call(grp.querySelectorAll('[data-key]'), function (l) { var k = l.getAttribute('data-key'); if (keep.indexOf(',' + k + ',') < 0) u[k] = 0; });
        write('cart/update.js', { updates: u });
      } else {
        write('cart/change.js', { id: ln.getAttribute('data-key'), quantity: Math.max(0, parseInt(q.getAttribute('data-qty'), 10) || 0) });
      }
      return;
    }
    var add = t.closest('[data-cgcd-up-add]');
    if (add) {
      e.preventDefault();
      if (d.classList.contains('is-busy')) return;
      add.setAttribute('aria-busy', 'true');
      var it = { id: +add.getAttribute('data-variant'), quantity: 1 }, slot = add.getAttribute('data-offer');
      if (slot) it.properties = { _cgc_cart_offer: slot };   /* hidden; measures the cart test */
      write('cart/add.js', { items: [it] });
      return;
    }
    /* quick sheet (cart test 10-19): engraving / options for a cross-sell, inside the drawer */
    var so = t.closest('[data-cgcd-sheet-open]');
    if (so) { e.preventDefault(); sheetOpen(document.getElementById(so.getAttribute('data-cgcd-sheet-open')), so); return; }
    if (t.closest('[data-cgcd-sheet-close]')) { e.preventDefault(); sheetClose(t.closest('[data-cgcd-sheet]')); return; }
    var sa = t.closest('[data-cgcd-sheet-add]');
    if (sa) { e.preventDefault(); if (!d.classList.contains('is-busy')) sheetAdd(sa.closest('[data-cgcd-sheet]')); }
  });

  /* ---------- cart offers: quick sheet ---------- */
  var sheetBack = null;
  function openSheet() { var d = drawer(); return d && d.querySelector('[data-cgcd-sheet]:not([hidden])'); }
  function sheetVariants(sh) { try { return JSON.parse(sh.querySelector('[data-cgcd-sh-variants]').textContent); } catch (e) { return []; } }
  function sheetPick(sh) {
    var groups = {}, n = 0;
    [].forEach.call(sh.querySelectorAll('[data-cgcd-sh-opt]'), function (r) { var i = +r.getAttribute('data-cgcd-sh-opt'); n = Math.max(n, i + 1); if (r.checked) groups[i] = r.value; });
    var vs = sheetVariants(sh), hit = null;
    if (!n) { hit = vs.filter(function (v) { return v.a; })[0] || null; }
    else vs.forEach(function (v) { if (hit) return; for (var i = 0; i < n; i++) if (v.o[i] !== groups[i]) return; hit = v; });
    var add = sh.querySelector('[data-cgcd-sheet-add]');
    [].forEach.call(sh.querySelectorAll('.cgcd-of__price'), function (pr) { pr.hidden = !hit || pr.getAttribute('data-v') !== String(hit.id); });
    if (hit && hit.a) { add.setAttribute('data-variant', hit.id); add.disabled = false; add.textContent = 'Add to cart'; }
    else { add.disabled = true; add.textContent = 'Sold out'; }
    var img = sh.querySelector('[data-cgcd-sh-img]'); if (img && hit && hit.img) img.src = hit.img;
    return hit;
  }
  function sheetOpen(sh, from) {
    if (!sh) return;
    var cur = openSheet(); if (cur && cur !== sh) cur.hidden = true;
    sheetBack = from || null;
    sh.hidden = false; sheetPick(sh); sheetErr(sh, '');
    var f = sh.querySelector('input[type="text"]') || sh.querySelector('.cgcd-sh__card');
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 30);
  }
  function sheetClose(sh) {
    if (!sh) return;
    sh.hidden = true;
    var b = sheetBack; sheetBack = null;
    if (b && document.contains(b)) try { b.focus({ preventScroll: true }); } catch (e) {}
  }
  function sheetErr(sh, msg) { var e = sh.querySelector('[data-cgcd-sh-err]'); if (e) { e.textContent = msg; e.hidden = !msg; } }
  function sheetAdd(sh) {
    if (!sh) return;
    var hit = sheetPick(sh); if (!hit || !hit.a) return;
    var mode = sh.getAttribute('data-eng'), gpo = sh.getAttribute('data-gpo'), props = {}, any = false, missing = null;
    var ins = [].slice.call(sh.querySelectorAll('input[data-prop]'));
    ins.forEach(function (i) { var v = i.value.trim(); i.classList.remove('is-bad'); if (v) { any = true; props[i.getAttribute('data-prop')] = v; } });
    /* bear + bracelets: every field; rose box: both hearts or neither (blank = plain hearts, no properties) */
    if (mode === 'req' || mode === 'all' || (mode === 'opt' && any)) ins.forEach(function (i) { if (!i.value.trim()) { i.classList.add('is-bad'); if (!missing) missing = i; } });
    if (missing) {
      sheetErr(sh, mode === 'all' ? 'Please fill in all four sides.' : (mode === 'opt' ? 'Add a name to both hearts, or leave both blank.' : 'Please add a name to both hearts.'));
      try { missing.focus(); } catch (e) {}
      return;
    }
    sheetErr(sh, '');
    if (gpo && (mode === 'all' || any)) props._has_gpo = gpo;
    props._cgc_cart_offer = sh.getAttribute('data-offer') || 'cross';
    var btn = sh.querySelector('[data-cgcd-sheet-add]'); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
    write('cart/add.js', { items: [{ id: hit.id, quantity: 1, properties: props }] });
  }
  /* a folded row's state, kept for this browser session */
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('details[data-cgcd-fold]')) return;
    var k = el.getAttribute('data-cgcd-fold');
    if (el.open) FOLDS[k] = 1; else delete FOLDS[k];
    try { sessionStorage.setItem('cgcd_folds', JSON.stringify(FOLDS)); } catch (er) {}
  }, true);
  document.addEventListener('change', function (e) {
    var d = drawer(), t = e.target;
    if (!d || !t || !d.contains(t)) return;
    if (t.matches('[data-qty-input]')) {
      var ln = line(t); if (!ln) return;
      write('cart/change.js', { id: ln.getAttribute('data-key'), quantity: Math.max(0, parseInt(t.value, 10) || 0) });
      return;
    }
    if (t.matches('[data-cgcd-sh-opt]')) { var sh = t.closest('[data-cgcd-sheet]'); if (sh) { sheetPick(sh); sheetErr(sh, ''); } return; }
    if (t.matches('[data-cgcd-of-select]')) {
      var of = t.closest('[data-cgcd-offer]'), ov = t.value, oo = t.options[t.selectedIndex];
      [].forEach.call(of.querySelectorAll(':scope > .cgcd-of__info .cgcd-of__price'), function (p) { p.hidden = p.getAttribute('data-v') !== ov; });
      var ob = of.querySelector('[data-cgcd-up-add]'); if (ob) ob.setAttribute('data-variant', ov);
      var oi = of.querySelector('[data-cgcd-of-img]'), os = oo && oo.getAttribute('data-img');
      if (oi && os) oi.src = os;
      return;
    }
    if (t.matches('[data-cgcd-up-select]')) {
      var card = t.closest('[data-cgcd-up]'), v = t.value, opt = t.options[t.selectedIndex];
      [].forEach.call(card.querySelectorAll('.cgcd-up__price'), function (p) { p.hidden = p.getAttribute('data-v') !== v; });
      var b = card.querySelector('[data-cgcd-up-add]'); if (b) b.setAttribute('data-variant', v);
      var img = card.querySelector('[data-cgcd-up-img]'), src = opt && opt.getAttribute('data-img');
      if (img && src) img.src = src;
    }
  });
  /* Enter in the quantity box updates without submitting anything */
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !isOpen) return;
    /* Enter in a sheet's engraving field = Add */
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-cgcd-sheet] input[data-prop]')) { e.preventDefault(); sheetAdd(e.target.closest('[data-cgcd-sheet]')); return; }
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); var os = openSheet(); if (os) sheetClose(os); else close(); return; }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-qty-input]')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key !== 'Tab') return;
    /* focus trap */
    var trap = openSheet() || d;
    var f = [].filter.call(trap.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
    if (!f.length) { e.preventDefault(); return; }
    /* move focus ourselves (Safari's default Tab skips links and buttons, and would leave the drawer) */
    var i = f.indexOf(document.activeElement);
    e.preventDefault();
    var n = i < 0 ? (e.shiftKey ? f.length - 1 : 0) : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length;
    f[n].focus();
  });

  document.addEventListener('cart:open', function () { open(); });
  document.addEventListener('cart:close', function () { close(); });
  document.addEventListener('cart:build', function () { dirty = true; refresh(); });
  document.addEventListener('ajaxProduct:added', function (e) { if (!(e.detail && e.detail.source === 'cgc-drawer')) open(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { dirty = true; refresh(); } });

  /* ---------- boot: read the summary the page printed (no request) ---------- */
  function boot() {
    var c = content();
    [].forEach.call(document.querySelectorAll('.js-drawer-open-cart'), function (a) {
      a.setAttribute('aria-controls', 'CgcCartDrawer'); a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-expanded', 'false');
    });
    if (c) {
      var cart = readCart(c);
      if (cart) { API.cart = cart; var cc = window.__cgcCart; if (cc && cc.remember && cart.item_count > cart.real_count) cc.remember(cart); }
    }
    /* never the /cart page (snippets/cgc-cart-assets.liquid): a bag tap held before this script loaded, or a bounce back from /cart */
    var want = !!window.__cgcOpenPending;
    try { if (sessionStorage.getItem('cgc_open_drawer')) { want = true; sessionStorage.removeItem('cgc_open_drawer'); } } catch (e) {}
    if (want) { window.__cgcOpenPending = 0; if (dirty || !c) refresh().then(open); else open(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
